<template>
  <div class="add-event-dialog">
    <!--<v-form ref="form" @input="modelChoise()" @input="modelChoise()">-->
    <v-form ref="form">
      <v-stepper class="my-steper" v-model="e6" vertical>
        <v-card-title v-if="editedEvent">
          {{ $t("addEventCard.UpdateEvent") }} #{{ editedEvent.details.id }}
        </v-card-title>
        <v-card-title v-else>
          {{ $t("addEventCard.createEvent") }}
        </v-card-title>

        <v-stepper-step
          :editable="value.courseId != null"
          :complete="value.courseId != null"
          step="1"
        >
          {{ $t("addEventCard.subTitle1") }}
        </v-stepper-step>

        <v-stepper-content step="1">
          <div>
            <v-card-text>
              <v-autocomplete
                id="courses-dropdown-add-event"
                :items="courses"
                item-text="title"
                item-value="id"
                :label="$t('addEventCard.subTitle1')"
                persistent-hint
                single-line
                :rules="emptyField"
                v-model="value.courseId"
              ></v-autocomplete>
            </v-card-text>

            <v-card-text>
              <v-textarea
                id="comment-add-event"
                auto-grow
                :label="$t('addEventCard.comment')"
                rows="1"
                row-height="30"
                v-model="value.comment"
                :rules="inputText"
              ></v-textarea>
            </v-card-text>
          </div>
          <v-card-actions>
            <v-btn
              :disabled="!value.courseId"
              color="primary"
              @click="e6 = 2"
              class="next-add-event"
            >
              {{ $t("addEventCard.next") }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn plain text color="secondary" @click="closeEvent">
              {{ $t("addEventCard.cancel") }}
            </v-btn>
          </v-card-actions>
        </v-stepper-content>

        <v-stepper-step
          :editable="value.dateEnd != null || value.dateStart != null"
          :complete="value.dateEnd != null || value.dateStart != null"
          step="2"
        >
          {{ $t("addEventCard.subTitle2") }}
        </v-stepper-step>

        <v-stepper-content step="2">
          <div>
            <v-row>
              <!-- date picker 1 -->
              <v-col cols="12" sm="6" md="6">
                <v-menu
                  v-model="datePickerStart"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-card-text>
                      <v-text-field
                        id="datepicker-start-add-event"
                        v-model="value.dateStart"
                        :label="$t('addEventCard.dateStart')"
                        prepend-icon="mdi-calendar"
                        :rules="emptyField"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </v-card-text>
                  </template>

                  <v-date-picker
                    v-model="value.dateStart"
                    :max="value.dateEnd"
                    :locale="this.$i18n.locale"
                    @input="datePickerStart = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <!-- date picker 2 -->
              <v-col cols="12" sm="6" md="6">
                <v-menu
                  v-model="datePickerEnd"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-card-text>
                      <v-text-field
                        id="datepicker-end-add-event"
                        v-model="value.dateEnd"
                        :label="$t('addEventCard.dateEnd')"
                        prepend-icon="mdi-calendar"
                        :rules="emptyField"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </v-card-text>
                  </template>

                  <v-date-picker
                    v-model="value.dateEnd"
                    :locale="this.$i18n.locale"
                    :min="value.dateStart"
                    @input="datePickerEnd = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <!-- TimePickers -->
            <v-row>
              <!-- time picker start -->
              <v-col cols="12" sm="6" md="6">
                <v-menu
                  ref="pickerStart"
                  v-model="timePickerStart"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-card-text>
                      <v-text-field
                        id="timepicker-start-add-event"
                        slot="activator"
                        :label="$t('addEventCard.timeStart')"
                        v-model="value.timeStart"
                        prepend-icon="mdi-clock"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </v-card-text>
                  </template>
                  <v-time-picker
                    v-if="timePickerStart"
                    v-model="value.timeStart"
                    :locale="this.$i18n.locale"
                    @click:minute="$refs.pickerStart.save()"
                  ></v-time-picker>
                </v-menu>
              </v-col>
              <!-- time picker end -->
              <v-col cols="12" sm="6" md="6">
                <v-menu
                  ref="pickerEnd"
                  v-model="timePickerEnd"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-card-text>
                      <v-text-field
                        id="timepicker-end-add-event"
                        slot="activator"
                        :label="$t('addEventCard.timeEnd')"
                        v-model="value.timeEnd"
                        prepend-icon="mdi-clock"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </v-card-text>
                  </template>
                  <v-time-picker
                    v-if="timePickerEnd"
                    v-model="value.timeEnd"
                    :locale="this.$i18n.locale"
                    @click:minute="$refs.pickerEnd.save()"
                  ></v-time-picker>
                </v-menu>
              </v-col>
            </v-row>
          </div>
          <v-card-actions>
            <v-btn
              class="next-add-event"
              :disabled="!value.dateStart || !value.dateEnd"
              color="primary"
              @click="e6 = 3"
            >
              {{ $t("addEventCard.next") }}
            </v-btn>
            <v-btn text @click="e6 = 1">
              {{ $t("addEventCard.back") }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn plain text color="secondary" @click="closeEvent">
              {{ $t("addEventCard.cancel") }}
            </v-btn>
          </v-card-actions>
        </v-stepper-content>

        <v-stepper-step
          :editable="value.userId != null || value.locationId != null"
          :complete="value.userId != null || value.locationId != null"
          step="3"
        >
          {{ $t("addEventCard.subTitle3") }}
        </v-stepper-step>

        <v-stepper-content step="3">
          <div>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <!-- city -->
                <v-card-text>
                  <v-autocomplete
                    id="locations-add-event"
                    :items="locations"
                    item-text="city"
                    item-value="id"
                    :label="$t('addEventCard.location')"
                    :rules="emptyField"
                    persistent-hint
                    single-line
                    v-model="value.locationId"
                  ></v-autocomplete>
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-card-text>
                  <v-autocomplete
                    id="users-add-event"
                    :items="users"
                    item-text="fullname"
                    item-value="id"
                    :label="$t('addEventCard.employee')"
                    :rules="emptyField"
                    persistent-hint
                    single-line
                    v-model="value.userId"
                  ></v-autocomplete>
                </v-card-text>
              </v-col>
            </v-row>
          </div>
          <v-card-actions>
            <v-btn
              class="next-add-event"
              :disabled="!value.userId || !value.locationId"
              color="primary"
              @click="e6 = 4"
            >
              {{ $t("addEventCard.next") }}
            </v-btn>
            <v-btn text @click="e6 = 2">
              {{ $t("addEventCard.back") }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn plain text color="secondary" @click="closeEvent">
              {{ $t("addEventCard.cancel") }}
            </v-btn>
          </v-card-actions>
        </v-stepper-content>

        <v-stepper-step step="4">
          {{ $t("addEventCard.subTitle5") }}
        </v-stepper-step>
        <v-stepper-content step="4">
          <div>
            <v-row>
              <!-- status -->
              <v-card-text>
                <v-radio-group mandatory row v-model="value.type">
                  <v-radio
                    id="type-add-event"
                    v-for="state in status"
                    :label="state.name"
                    :value="state.id"
                    :key="state.id"
                    :rules="emptyField"
                  ></v-radio>
                </v-radio-group>
                <!-- valide -->
                <v-switch
                  id="validated-add-event"
                  :label="$t('addEventCard.confirm')"
                  v-model="value.validated"
                ></v-switch>
              </v-card-text>

              <!-- Start Link to a master Event -->
              <v-card-text>
                <v-switch
                  :label="$t('addEventCard.linkParentTitle')"
                  v-model="linkToMaster"
                ></v-switch>
                <v-autocomplete
                  v-if="linkToMaster"
                  :items="masterInterventions"
                  item-value="id"
                  :label="$t('addEventCard.linkParent')"
                  :rules="emptyField"
                  persistent-hint
                  single-line
                  v-model="value.masterInterventionId"
                >
                  <template slot="selection" slot-scope="data">
                    {{ data.item.id }} - {{ data.item.comment }}
                  </template>
                  <template slot="item" slot-scope="data">
                    {{ data.item.id }} - {{ data.item.comment }}
                  </template>
                </v-autocomplete>
              </v-card-text>
              <!-- End Link to a master Event -->
            </v-row>
          </div>
          <v-card-actions>
            <v-btn color="success" @click="addAnEvent" id="create-add-event">
              <div v-if="this.isEditing">
                {{ $t("addEventCard.update") }}
              </div>
              <div v-else>
                {{ $t("addEventCard.create") }}
              </div>
            </v-btn>
            <v-btn text @click="e6 = 3">
              {{ $t("addEventCard.back") }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn plain text color="secondary" @click="closeEvent">
              {{ $t("addEventCard.cancel") }}
            </v-btn>
          </v-card-actions>
        </v-stepper-content>
        <div v-if="errors" class="errors">
          {{ this.currentDropError }}
        </div>
        <div v-if="errorsBackEnd">
          <ul class="errors errorsList">
            <li v-for="e in errorBackend" :key="e.valueE">{{ e.valueE }}</li>
          </ul>
        </div>
      </v-stepper>
      <!-- Start Error messages from the BackEnd -->
      <!-- End Error messages from the BackEnd -->
    </v-form>
  </div>
</template>

<script>
import EventInfoCardVue from "../event-details/EventInfoCard.vue";
import { mapActions, mapGetters } from "vuex";
import EventModule from "@/store/planning/eventStore";
import InterventionFollowedModule from "@/store/planning/interventionFollowedStore";
import LeavePeriodModule from "@/store/planning/leavePeriodStore";
import FreeDaysModule from "@/store/planning/freeDaysStore";

export default {
  components: {
    EventInfoCardVue,
  },
  props: {
    editedEvent: null,
  },
  data() {
    return {
      e6: 1,
      datePickerStart: false,
      datePickerEnd: false,
      timePickerStart: false,
      timePickerEnd: false,
      isEditing: false,
      menu: false,
      hasSaved: false,
      status: [
        { id: "INTERN", name: this.$t("addEventCard.intern") },
        { id: "INTRA", name: this.$t("addEventCard.custom") },
        { id: "POE", name: this.$t("addEventCard.eop") },
        { id: "TP", name: this.$t("addEventCard.professionalTitle") },
        { id: "SOUS_TRAITANT", name: this.$t("addEventCard.subcontracting") },
      ],
      errors: false,
      errorsBackEnd: false,
      linkToMaster: false,
      value: {
        eventTitle: null,
        courseId: null,
        courseIdDg2: null,
        comment: null,
        locationId: null,
        locationIdDg2: null,
        userId: null,
        dateStart: null,
        dateEnd: null,
        timeStart: "09:00",
        timeEnd: "17:00",
        validated: null,
        type: null,
      },
      emptyField: [(v) => !!v || this.$t("errorFrontEnd.requiredField")],
      inputText: [
        (v) => !!v || this.$t("errorFrontEnd.requiredField"),
        (v) =>
          /^[ A-Za-z0-9_@./#&+-:()]*$/.test(v) ||
          this.$t("errorFrontEnd.specialCharacters"),
      ],
      dropErrors: new Map([
        ["trainingsConflict", this.$t("errorDialog.trainingsConflict")],
        ["interFollowConflict", this.$t("errorDialog.interFollow")],
        ["freeDay", this.$t("errorDialog.freeDay")],
        ["leavePeriod", this.$t("errorDialog.leavePeriod")],
        ["holiday", this.$t("errorDialog.holiday")],
      ]),
      currentDropError: null,
    };
  },
  computed: {
    ...mapGetters("locationModule", { locations: "getLocations" }),
    ...mapGetters("courseModule", { courses: "getCourses" }),
    ...mapGetters("userModule", { users: "getUsersForm" }),
    ...mapGetters("notificationModule", { errorBackend: "getErrorBackend" }),
    ...mapGetters("eventModule", { masterInterventions: "getMasterEvents" }),
    ...mapGetters("interventionFollowedModule", {
      interFollow: "getInterventionsFollowed",
    }),
  },
  watch: {
    editedEvent: function () {
      if (this.editedEvent != null) {
        this.value = this.advIntervToIntervDto(this.editedEvent);
      }
    },
  },
  mounted() {
    if (this.editedEvent != null) {
      this.value = this.advIntervToIntervDto(this.editedEvent);
      this.isEditing = true;
    } else {
      this.isEditing = false;
    }
  },
  methods: {
    ...mapActions("eventModule", ["addEvent", "editEvent"]),
    ...mapActions("notificationModule", ["emptyErrorMessages"]),
    advIntervToIntervDto(event) {
      if (event.details) {
        return {
          eventTitle: event.details.course.title,
          courseId: event.details.course.id,
          courseIdDg2: event.details.course.idDg2,
          comment: event.details.comment,
          locationId: event.details.location.id,
          locationIdDg2: event.details.location.idDg2,
          userId: event.details.user.id,
          dateStart: event.details.dateStart,
          dateEnd: event.details.dateEnd,
          timeStart: event.details.timeStart,
          timeEnd: event.details.timeEnd,
          validated: event.details.validated,
          type: event.details.type,
          version: event.details.version,
          id: event.details.id,
          slug: event.details.slug,
          idDg2: event.details.idDg2,
          attendeesCount: event.details.attendeesCount,
        };
      } else {
        return {
          eventTitle: event.course.title,
          courseId: event.course.id,
          courseIdDg2: event.course.idDg2,
          comment: event.comment,
          locationId: event.location.id,
          locationIdDg2: event.location.idDg2,
          userId: event.user.id,
          dateStart: event.dateStart,
          dateEnd: event.dateEnd,
          timeStart: event.timeStart,
          timeEnd: event.timeEnd,
          validated: event.validated,
          type: event.type,
          version: event.version,
          id: event.id,
          slug: event.slug,
          idDg2: event.idDg2,
          attendeesCount: event.attendeesCount,
        };
      }
    },
    addAnEvent() {
      this.emptyErrorMessages(); // when close by clicking on the side
      this.errors = false;
      this.errorsBackEnd = false;
      this.currentDropError = "";

      const start = this.value.dateStart;
      const end = this.value.dateEnd;
      // const eventId = this.editedEvent.id;
      let eventId = 0;
      if (this.editedEvent !== undefined) {
        eventId = this.editedEvent.id;
      }

      const user = this.users.find((u) => u.id === this.value.userId);
      const courseName = this.courses.find(
        (c) => c.id === this.value.courseId
      ).title;

      //Check validity of intervention before persisting

      if (
        FreeDaysModule.methods.isHoliDay(start) ||
        FreeDaysModule.methods.isHoliDay(end)
      ) {
        this.currentDropError = this.dropErrors.get("holiday");
      }

      if (
        FreeDaysModule.methods.isWeekEndDay(start) ||
        FreeDaysModule.methods.isWeekEndDay(end)
      ) {
        this.currentDropError = this.dropErrors.get("freeDay");
      }

      if (
        !EventModule.methods.intervalIsEmptyStartAndEnd(
          start,
          end,
          eventId,
          courseName,
          user
        )
      ) {
        this.currentDropError = this.dropErrors.get("trainingsConflict");
      }

      if (
        !InterventionFollowedModule.methods.intervalIsEmptyIntFollowStartEnd(
          start,
          end,
          user
        )
      ) {
        this.currentDropError = this.dropErrors.get("interFollowConflict");
      }

      if (
        !LeavePeriodModule.methods.intervalIsEmptyLeavePeriodStartEnd(
          start,
          end,
          user
        )
      ) {
        this.currentDropError = this.dropErrors.get("leavePeriod");
      }

      if (this.currentDropError != "") {
        setTimeout(() => {
          this.errors = true;
        }, 200);
      } else {
        if (this.editedEvent != null) {
          //Check if if there is followed interventions that overlap with other interventions
          let interFollowErrorMessage = "";
          let followedToChange = this.interFollow.filter(
            (int) => int.details.interventionId === this.value.id
          );

          followedToChange.forEach((element) => {
            let user = this.users.find((u) => u.id === element.details.userId);
            interFollowErrorMessage +=
              InterventionFollowedModule.methods.checkIfInterventionFollowedOverlapsWithOtherEvents(
                user,
                start,
                end,
                element
              );
          });

          if (interFollowErrorMessage != "") {
            this.currentDropError = interFollowErrorMessage;
            setTimeout(() => {
              this.errors = true;
            }, 200);
          } else {
            this.editEvent(this.value).then((e) => {
              if (this.errorBackend.length === 0) {
                this.closeEvent();
              } else {
                this.errorsBackEnd = true;
                this.e6 = 1;
              }
            });
          }
        } else {
          this.addEvent(this.value).then((e) => {
            if (this.errorBackend.length === 0) {
              this.closeEvent();
            } else {
              //TODO Message to tell user there is a mistake in back end
              this.errorsBackEnd = true;
              this.e6 = 1;
            }
          });
        }
      }
    },
    closeEvent() {
      this.value = {};
      this.$refs.form.reset();
      this.errors = false;
      this.errorsBackEnd = false;
      this.e6 = 1;
      this.emptyErrorMessages();
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss">
.add-event-dialog {
  border-radius: 50px;
  height: 100%;
  overflow: auto;

  .v-form {
    .my-steper {
      height: 100%;
      background: none;
      box-shadow: none;

      .v-card__title {
        text-align: center;
        justify-content: center;
        color: white;
        background-color: #1975d2;
      }
    }
  }

  button {
    margin: 0 10px 0 0;
  }
}

.errors {
  color: red;
}

.errorsList {
  list-style-type: none;
}
</style>
